// react
import React, { Fragment, useEffect, useState } from 'react'
// store
import { API, PAGINATION_LIMIT } from '../../../../store/config'
//import moment from 'moment'
// components
import DimmerLoader from '../../../../components/others/DimmerLoader'
import { Table, Pagination, Icon, Card } from 'semantic-ui-react'

// component
function ClientInvoicesTable({ invoices, isLoading }) {
    const [ready, setReady] = useState(false)
    const [isMobile, setIsMobile] = useState(false)
    // state
    const [invoicesList, setInvoicesList] = useState(invoices.slice(0, PAGINATION_LIMIT))

    // set data to table
    useEffect(() => {
        setInvoicesList(invoices.slice(0, PAGINATION_LIMIT))
        setReady(true)
    }, [invoices])

    useEffect(() => {
        const media = window.matchMedia("(max-width: 768px)");
        const handleChange = () => setIsMobile(media.matches);
        handleChange();
        if (media.addEventListener) {
            media.addEventListener("change", handleChange);
        } else {
            media.addListener(handleChange);
        }
        return () => {
            if (media.removeEventListener) {
                media.removeEventListener("change", handleChange);
            } else {
                media.removeListener(handleChange);
            }
        };
    }, []);

    const handleChangePage = (event, data) => {
        setReady(false)
        setInvoicesList(
            invoices.slice(data.activePage * PAGINATION_LIMIT - PAGINATION_LIMIT, data.activePage * PAGINATION_LIMIT)
        )
        setReady(true)
    }

    // template
    const totalPages = Math.ceil(invoices.length / PAGINATION_LIMIT) || 1;

    return (
        <Fragment>
            <DimmerLoader active={isLoading} />
            {isMobile ? (
                <div>
                    {invoicesList.length === 0 && (
                        <Card fluid style={{ borderRadius: "16px", textAlign: "center", boxShadow: "0 4px 16px rgba(0,0,0,0.06)", border: "1px solid rgba(0,0,0,0.06)" }}>
                            <Card.Content style={{ padding: "2rem 1rem" }}>
                                <div style={{ color: "rgba(0,0,0,0.4)", marginBottom: "0.5rem", display: "flex", justifyContent: "center" }}>
                                    <Icon name="inbox" style={{ fontSize: "2.5rem", margin: 0, display: "flex", alignItems: "center" }} />
                                </div>
                                <strong style={{ fontSize: "0.95rem", color: "rgba(0,0,0,0.7)", lineHeight: 1.4 }}>Neboli najdené žiadne záznamy</strong>
                            </Card.Content>
                        </Card>
                    )}
                    {invoicesList.map((invoice) => (
                        <Card key={invoice.id} fluid style={{ marginBottom: "1rem", borderRadius: "16px", overflow: "hidden", boxShadow: "0 4px 16px rgba(0,0,0,0.08)", border: "1px solid rgba(0,0,0,0.06)", background: "#fff" }}>
                            <Card.Content style={{ padding: "1rem 1.1rem 0.9rem", background: invoice.status === 3 ? "linear-gradient(135deg, rgba(0,166,81,0.04) 0%, rgba(255,255,255,0) 100%)" : "linear-gradient(135deg, rgba(219,40,40,0.04) 0%, rgba(255,255,255,0) 100%)" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "0.7rem" }}>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ fontSize: "0.7rem", fontWeight: 600, color: "rgba(0,0,0,0.45)", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "0.25rem" }}>Faktúra</div>
                                        <div style={{ fontWeight: 700, fontSize: "1.1rem", color: "#1a1a1a", lineHeight: 1.2 }}>{invoice.invoice_number}</div>
                                    </div>
                                    <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", padding: "0.35rem 0.75rem", borderRadius: "20px", background: invoice.status === 3 ? "#00a651" : "#db2828", color: "#fff", fontWeight: 700, fontSize: "0.75rem", lineHeight: 1.2, whiteSpace: "nowrap", boxShadow: invoice.status === 3 ? "0 2px 8px rgba(0,166,81,0.25)" : "0 2px 8px rgba(219,40,40,0.25)" }}>
                                        <Icon name={invoice.status === 3 ? "check circle" : "times circle"} style={{ margin: "0 0.3rem 0 0", fontSize: "0.85rem", display: "flex", alignItems: "center" }} />
                                        {invoice.status === 3 ? "Zaplatená" : "Nezaplatená"}
                                    </div>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: "0.4rem", padding: "0.5rem 0.65rem", borderRadius: "10px", background: "rgba(0,0,0,0.03)", border: "1px solid rgba(0,0,0,0.06)" }}>
                                    <Icon name="clipboard outline" style={{ margin: 0, fontSize: "0.9rem", color: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center" }} />
                                    <span style={{ fontSize: "0.85rem", color: "rgba(0,0,0,0.75)", fontWeight: 500, lineHeight: 1.2 }}>
                                        {invoice.service.service_type === 1 ? "Objednávka Termínu" : "Objednávka"}
                                    </span>
                                </div>
                            </Card.Content>
                            <Card.Content style={{ padding: "1rem 1.1rem", background: "#fafafa" }}>
                                <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "0.85rem" }}>
                                    <div style={{ padding: "0.65rem 0.75rem", borderRadius: "12px", background: "#fff", border: "1px solid rgba(0,0,0,0.08)" }}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "0.35rem", marginBottom: "0.3rem" }}>
                                            <Icon name="euro sign" style={{ margin: 0, fontSize: "0.75rem", color: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center" }} />
                                            <span style={{ fontSize: "0.7rem", color: "rgba(0,0,0,0.5)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.3px", lineHeight: 1 }}>Cena</span>
                                        </div>
                                        <div style={{ fontWeight: 700, fontSize: "1.05rem", color: "#1a1a1a", lineHeight: 1.3 }}>{`${invoice.total_amount} €`}</div>
                                    </div>
                                    <div style={{ padding: "0.65rem 0.75rem", borderRadius: "12px", background: "#fff", border: "1px solid rgba(0,0,0,0.08)" }}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "0.35rem", marginBottom: "0.3rem" }}>
                                            <Icon name="calendar alternate outline" style={{ margin: 0, fontSize: "0.75rem", color: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center" }} />
                                            <span style={{ fontSize: "0.7rem", color: "rgba(0,0,0,0.5)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.3px", lineHeight: 1 }}>Objednané</span>
                                        </div>
                                        <div style={{ fontWeight: 700, fontSize: "0.95rem", color: "#1a1a1a", lineHeight: 1.3 }}>{invoice.ordered_when}</div>
                                    </div>
                                </div>
                            </Card.Content>
                            {(invoice.status === 3 && invoice.ordered_items.filter((item) => item.event.event_type === 'solidarity').length === 0 && ready) && (
                                <Card.Content style={{ padding: "0.75rem 1.1rem", background: "var(--primary)", borderTop: "none" }}>
                                    <a href={API.INVOICES + invoice.id + "/docs/"} rel="noopener noreferrer" target="_blank" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem", color: "#fff", fontWeight: 700, fontSize: "0.9rem", textDecoration: "none", lineHeight: 1 }}>
                                        <Icon name="download" style={{ margin: 0, fontSize: "1rem", display: "flex", alignItems: "center" }} />
                                        <span style={{ lineHeight: 1 }}>Stiahnuť doklad</span>
                                    </a>
                                </Card.Content>
                            )}
                        </Card>
                    ))}
                    {totalPages > 1 && (
                        <div style={{ display: "flex", justifyContent: "center", marginTop: "1.5rem", marginBottom: "1rem" }}>
                            <Pagination
                                defaultActivePage={1}
                                totalPages={totalPages}
                                onPageChange={handleChangePage}
                                boundaryRange={0}
                                siblingRange={1}
                            />
                        </div>
                    )}
                </div>
            ) : (
                <Card fluid style={{ borderRadius: "14px", boxShadow: "0 2px 10px rgba(0,0,0,0.06)" }}>
                    <Card.Content style={{ padding: "0.5rem 0.75rem" }}>
                        <div style={{ overflowX: "auto" }}>
                            <Table striped unstackable style={{ minWidth: "900px" }}>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Číslo faktúry</Table.HeaderCell>
                                        <Table.HeaderCell>Služba</Table.HeaderCell>
                                        <Table.HeaderCell>Celková cena</Table.HeaderCell>
                                        <Table.HeaderCell>Objednané</Table.HeaderCell>
                                        <Table.HeaderCell>Stav</Table.HeaderCell>
                                        <Table.HeaderCell>Faktúra</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {invoicesList.length === 0 && (
                                        <Table.Row>
                                            <Table.Cell colSpan={6} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                Neboli najdené žiadne záznamy
                                            </Table.Cell>
                                        </Table.Row>
                                    )}
                                    {invoicesList.map((invoice) => (
                                        <Table.Row key={invoice.id}>
                                            <Table.Cell>{invoice.invoice_number}</Table.Cell>
                                            <Table.Cell>
                                                {invoice.service.service_type === 1 ? 'Objednávka Termínu' : 'Objednávka'}
                                            </Table.Cell>
                                            <Table.Cell>{`${invoice.total_amount} €`}</Table.Cell>
                                            <Table.Cell>{invoice.ordered_when}</Table.Cell>
                                            <Table.Cell>
                                                <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", padding: "0.35rem 0.75rem", borderRadius: "20px", background: invoice.status === 3 ? "#00a651" : "#db2828", color: "#fff", fontWeight: 700, fontSize: "0.75rem", lineHeight: 1.2, whiteSpace: "nowrap", boxShadow: invoice.status === 3 ? "0 2px 8px rgba(0,166,81,0.25)" : "0 2px 8px rgba(219,40,40,0.25)" }}>
                                                    <Icon name={invoice.status === 3 ? "check circle" : "times circle"} style={{ margin: "0 0.3rem 0 0", fontSize: "0.85rem", display: "flex", alignItems: "center" }} />
                                                    {invoice.status === 3 ? "Zaplatená" : "Nezaplatená"}
                                                </div>
                                            </Table.Cell>
                                            <Table.Cell>
                                                {invoice.status === 3 &&
                                                    invoice.ordered_items.filter((item) => item.event.event_type === 'solidarity')
                                                        .length === 0 &&
                                                    ready && (
                                                        <a
                                                            href={API.INVOICES + invoice.id + '/docs/'}
                                                            rel="noopener noreferrer"
                                                            target="_blank"
                                                        >
                                                            <Icon name="file pdf" style={{ fontSize: '1.2rem', color: 'red' }} />
                                                        </a>
                                                    )}
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}
                                </Table.Body>

                                <Table.Footer>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan="8">
                                            <Pagination
                                                defaultActivePage={1}
                                                totalPages={totalPages}
                                                onPageChange={handleChangePage}
                                                boundaryRange={0}
                                                siblingRange={0}
                                            />
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Footer>
                            </Table>
                        </div>
                    </Card.Content>
                </Card>
            )}
        </Fragment>
    )
}

export default ClientInvoicesTable
